module.exports = __webpack_public_path__ + "img/1-2.dd691023.svg";